module.exports = __webpack_public_path__ + "img/success2.f3d06709.png";